"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var lab_1 = require("@material-ui/lab");

var Alert = function Alert(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'success' : _props$type,
      children = props.children;
  return react_1.default.createElement(lab_1.Alert, {
    severity: type
  }, children);
};

exports.default = Alert;